/**
 * Defines the environment of the API domains.
 *
 * @public
 */
export enum Environment {
  PROD = 'prod',
  SANDBOX = 'sbx',
  /** For internal development only */
  QA = 'qa',
  /** For internal development only */
  DEV = 'dev',
}